export default __webpack_public_path__ + "KaTeX_Fraktur-Bold.5b8749ee09f3aa84381365edac89c624.woff2";